import { Button, Text } from '@epam/promo';
import { ReactComponent as leftIcon } from '@epam/assets/icons/common/navigation-chevron-left-24.svg';
import { ReactComponent as rightIcon } from '@epam/assets/icons/common/navigation-chevron-right-24.svg';

interface AISuggestionSwitcherProps {
  amount: number;
  active: number;
  setActive: (value: number) => void;
}

export const AISuggestionSwitcher = ({
  amount,
  active,
  setActive,
}: AISuggestionSwitcherProps) => {
  const onLeftClick = () => setActive(active - 1);
  const onRightClick = () => setActive(active + 1);

  if (!amount || amount === 1) {
    return <div />;
  }

  return (
    <div style={{ display: 'flex' }}>
      <Button
        fill="light"
        icon={leftIcon}
        isDisabled={active === 0}
        size="30"
        onClick={onLeftClick}
      />
      <Text size="30">
        {active + 1} / {amount}
      </Text>
      <Button
        fill="light"
        icon={rightIcon}
        isDisabled={active === amount - 1}
        size="30"
        onClick={onRightClick}
      />
    </div>
  );
};
